import React, { useState } from "react"
import { useTranslation, Trans } from "react-i18next"
import Typography from "@/components/Typography"
import Block from "@/components/Block"
import { Container } from "./components/Container"
import styled from "@emotion/styled"
import { QRDownloadBtn } from "@/components/QRDownloadBtn"
import { DownloadCTA } from "./components/DownloadCTA"
import Box from "@/components/Box"
import Flex from "@/components/Flex"
import Link from "@/components/Link"
import Button from "@/components/Button"

const GradientText = styled(Typography)`
  background: linear-gradient(90deg, #1199fa 0%, #0b1426 100%);
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
`

export const DownloadAppSection = () => {
  const { t, i18n } = useTranslation("payCustomer")
  const [isQRCodeOpen, setQRCodeOpen] = useState(false)
  return (
    <Block backgroundColor={"#FFF"}>
      <Container>
        <Box mb={[20, 20, 9]}>
          <GradientText
            textAlign={"center"}
            as="h1"
            variant="h1"
            maxWidth={700}
            mx={"auto"}
            mb={[3]}
          >
            {t("shopping.get_started_title")}
          </GradientText>
          <Typography
            maxWidth={["unset", 263, 470]}
            mx={"auto"}
            mb={[3, 3, 5]}
            variant="p"
            textAlign={"center"}
            color={"#565F76"}
            fontSize={[17, 17, 20]}
            fontWeight={600}
            lineHeight={"140%"}
          >
            {t("shopping.get_started_description")}
          </Typography>
          <Box
            display={["none", "none", "block"]}
            minHeight={["167px"]}
            width={"max-content"}
            mx="auto"
            className="pay-cta-get-started"
          >
            <QRDownloadBtn
              isQRCodeOpen={isQRCodeOpen}
              setQRCodeOpen={setQRCodeOpen}
              ctaText={t("shopping.button")}
              qrCodeType={"mainApp"}
              color="#FFF"
              border="1px solid #0577DA"
              background="#0577DA"
              campaign="pay"
              isShowOneLinkQR
            />
          </Box>
          <Box
            display={["flex", "flex", "none"]}
            justifyContent={"center"}
            className="pay-cta-get-started"
          >
            <DownloadCTA
              bg={"#0577DA"}
              color={"#FFF"}
              text={t("shopping.button")}
              curLang={i18n.language}
              campaign="pay"
            />
          </Box>
        </Box>
        <Flex
          width={["100%", 728, 1080]}
          flexDirection={["column-reverse", "row", "row"]}
          borderRadius={[16, 16, 20]}
          bg={"#F7F9FA"}
        >
          <Flex p={4} flexDirection={"column"} width={["100%", 335, 365]}>
            <Typography
              mb={[3, 3, 6]}
              color="#0B1426"
              variant="p"
              fontSize={28}
              fontWeight={600}
              lineHeight={"140%"}
              minHeight={156}
            >
              <Trans
                i18nKey={"shopping.paymerchant_title"}
                t={t}
                components={{
                  highlight: <span style={{ color: "#0577DA" }}></span>,
                }}
              />
            </Typography>
            <Link href={"https://merchant.crypto.com/users/sign_up"}>
              <Button
                variant="primaryBlack"
                className="pay-cta-merchant-sign-up"
              >
                <Box
                  as="img"
                  src={`${process.env.ASSETS_BASE_URL}/pay/customer-page/pay-logo.webp`}
                  width={"59px"}
                  height={"26px"}
                  loading="lazy"
                  mr={"5px"}
                  alt="Crypto.com logo with PAY text, representing secure and convenient payment options for cryptocurrencies and digital assets."
                />
                <Typography
                  pt={"3px"}
                  variant="p"
                  color={"#F7F9FA"}
                  fontSize={16}
                  fontWeight={600}
                  lineHeight={"110%"}
                >
                  {t("shopping.paymerchant_button")}
                </Typography>
              </Button>
            </Link>
          </Flex>
          <Box
            display={["block", "block", "none"]}
            as="img"
            borderRadius={["16px 16px 0px 0px", "0px 16px 16px 0px"]}
            width={["100%", 393]}
            height={[250, "auto"]}
            src={`${process.env.ASSETS_BASE_URL}/pay/customer-page/pay-merchant-sm.webp`}
            loading="lazy"
            alt="Image: Real-life scenario of two individuals using Crypto.com Pay. One person on the right is making a payment using their phone, while a bakery staff member on the left awaits the completion of the transaction."
          />
          <Box
            display={["none", "none", "block"]}
            borderRadius={"0px 20px 20px 0px"}
            as="img"
            width={[715]}
            height={["auto"]}
            src={`${process.env.ASSETS_BASE_URL}/pay/customer-page/pay-merchant.webp`}
            loading="lazy"
            alt="Image: Real-life scenario of two individuals using Crypto.com Pay. One person on the right is making a payment using their phone, while a bakery staff member on the left awaits the completion of the transaction."
          />
        </Flex>
      </Container>
    </Block>
  )
}
